/* eslint-disable no-param-reassign */
const _buildPages = (item, survey) => {
  // include only 3 qtypes
  if (item.question.__typename === 'SingleChoiceQuestion' || item.question.__typename === 'MultipleChoiceQuestion') {
    if (!survey[item.question.pageId]) {
      survey[item.question.pageId] = [];
    }
    survey[item.question.pageId].push(item);
    item.answeredLookup = {};
    item.answers.forEach(answer => {
      item.answeredLookup[answer.row.id] = true;
    });
  }
};

const _populateResponded = item => {
  if (item.question.options) {
    // eslint-disable-next-line no-unused-expressions
    item.question.options.items &&
      item.question.options.items.forEach(option => {
        if (item.answeredLookup[option.id]) {
          option.responded = true;
        }
      });
  }
};

const formatSurvey = items => {
  const survey = {};
  if (items) {
    items.forEach(item => {
      _buildPages(item, survey);
      _populateResponded(item);
    });
  }
  return survey;
};

export default formatSurvey;
